import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import AuthPageContainer from "@/features/auth/containers/auth-page-container";
import { beforeGuestGuard } from "@/features/auth/guards";

const registerSearchSchema = z.object({
  redirect: z.string().optional(),
  type: z.string().optional(),
});

// Inferred child route: /register
export const Route = createFileRoute("/register")({
  beforeLoad: beforeGuestGuard,
  ssr: false,
  validateSearch: (search) => registerSearchSchema.parse(search),
  component: () => <AuthPageContainer mode="register" />,
});
